import Vue from 'vue'
import App from './App.vue'
import Vuetify from 'vuetify'
import VueMaterial from 'vue-material'
import axios from 'axios';
import router from './routes';
import Notifications from 'vue-notification';
import '@fortawesome/fontawesome-free/css/all.css'
import '@fortawesome/fontawesome-free/js/all.js'

import 'vuetify/dist/vuetify.min.css'
import 'vue-material/dist/vue-material.min.css'
import './registerServiceWorker'

import { FormatDate, FormatMoney, FormatPhone, FormatDateTime, FormatCnpj } from './filters';


Vue.prototype.$user = null;


const instance = axios.create({
  baseURL: "https://api.pedidos.infous.com.br/api"
});

let token = localStorage.getItem("api_token");
if (token) {
  instance.defaults.headers.common['Authorization'] = 'Bearer ' + token;
} else {
  console.log(token);
}

Vue.prototype.$http = instance;
Vue.use(Notifications);
Vue.use(VueMaterial)

Vue.use(Vuetify)

Vue.config.productionTip = false
Vue.component('Layout', () => import('./components/Layout.vue'));
Vue.component('client-form', () => import('./pages/clients/Form.vue'));
Vue.component('palce-form', () => import('./pages/clients/AddressForm.vue'));
Vue.component('product-form', () => import('./pages/products/Form.vue'));
Vue.component('type-payments-form', () => import('./pages/type_payments/Form.vue'));
Vue.component('order-form', () => import('./pages/sales_orders/Form.vue'));
Vue.component('user-form', () => import('./pages/users/Form.vue'));

Vue.filter('formatMoney', FormatMoney);
Vue.filter('formatDate', FormatDate);
Vue.filter('formatCnpj', FormatCnpj);
Vue.filter('formatPhone', FormatPhone);
Vue.filter('formatDateTime', FormatDateTime);

// const vuetifyOptions = {
//   primary: "orange"
// }

new Vue({
  router,
  render: h => h(App),
  vuetify: new Vuetify({
    theme: {
      themes: {
        light: {
          primary: '#ff9800',
          secondary: '#b0bec5',
          accent: '#8c9eff',
          error: '#b71c1c',
        },
      },
    },
  })
}).$mount('#app')
